module.exports = __webpack_public_path__ + "static/media/message-circle-down.be52745d.svg";